export default {
    // Currently used
    home_search_for_product: "Zoek naar uw product",
    conventional_alternative: "Conventioneel alternatief",
    led_alternative: "LED alternatief",
    alt_filters_filter: "LED alternatief filter",
    search_filters_filter: "Filter",
    search_submit: "Zoek product",
    results: "Resultaten",
    selected_product: "Geselecteerd product",
    search_input: "Typ (een deel van) de productcode of omschrijving in",
    what_type_are_you_looking_for: "Naar welk type productvervanging bent u op zoek?",
    recommendations_singular: "Aanbevelingen",
    recommendations_plural: "Aanbevelingen",
    your_product: "Uw product",
    search_filters_reset: "Filters opnieuw instellen",
    results_specify: "Er zijn meer dan 10 resultaten, specificeer uw zoekopdracht",
    energy_efficient: "Energiezuinig",
    active_filters: "Actieve filters",
    card_action: "Catalogus",
    card_show_more: "Toon meer",
    card_show_less: "Toon minder",
    card_alternative_fit: "Philips beste alternatief",
    card_perfect_fit: "Philips beste keuze",
    no_results_found: "Geen resultaten gevonden. Probeer een andere zoekopdracht",
    results_no_recommendations: "Loopt u vast? Neem contact op met uw lokale accountmanager of vertegenwoordiger om een oplossing te vinden.",
    led_no_recommendations: "Er zijn geen LED alternatieven voor dit product",
    ballast_notice: "Raadpleeg de compatibiliteitslijst bij gebruik van electronische ballast (HF).",
    ballast_notice_tled_link_text: "LEDtube compatibiliteitslijst",
    ballast_notice_pl_led_link_text: "LED PL lampen compatibiliteitslijst",
  
    // LED facets
    search_filter_product_type: "Product type",
    lighting_type: "Type Lamp",
    ean: "EAN",
    product_code: "Productcode",
    eoc: "EOC",
    family: "Familie",
    discrete_wattage: "Vermogen",
    wattage: "Vermogen",
    brand: "Merk",
    driver_type: "Type driver",
    number_of_lamps: "Aantal lampen",
    length: "Lengte",
    color: "Kleur",
    base: "Fitting",
    local_eoc: "Lokale code",
    lumen: "Lumen",
    energy_saving: "Energiebesparend",
    tiering: "Groepen",
    ballast_compatibility: "Ballast compatibiliteit",
    lifetime: "Levensduur",

    // Conventional facets
    ignitor: "Ontsteker",
    height: "Hoogte",
    width: "Breedte",
    mounting_hole: "Montage gat",
    mains_voltage: "Netspanning",
    thermal_protection: "Thermische bescherming",
    delta_temperature: "Delta Temperatuur",
    energy_efficiency: "Energie-efficiëntie",
    losses: "Verliezen",
    lamp_current: "Lamp stroom",
    pf_cap: "PF-dop",
};
